// Catálogo de presentación de Configuración global, transcrito del mock: nombres, orden y rangos.
// Los valores de todo param con binding (mapping.ts) los pisa el servidor.
import type { SystemParam } from './types';

const ADMIN = 'Administrador del Sistema';

export const SYSTEM_PARAMS: SystemParam[] = [
    // ---------- WIZARD · ventanas de tiempo ----------
    {
        id: 'wiz.cotizacion_vigencia_min',
        name: 'Vigencia de la cotización',
        description: 'Tiempo que el vendedor tiene para cerrar la venta antes de recotizar',
        category: 'wizard',
        kind: 'minutes',
        value: 30,
        defaultValue: 30,
        min: 5,
        max: 120,
        editable: true,
        lastModified: '2026-05-14',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'wiz.reserva_producto_min',
        name: 'Ventana de reserva de producto',
        description: 'Tiempo que se aparta el equipo tras seleccionar en el Paso 03',
        category: 'wizard',
        kind: 'minutes',
        value: 30,
        defaultValue: 30,
        min: 10,
        max: 90,
        editable: true,
        lastModified: '2026-05-14',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'wiz.otp_timeout_min',
        name: 'Timeout del OTP',
        description: 'Vigencia del código OTP enviado al cliente en el Paso 01',
        category: 'wizard',
        kind: 'minutes',
        value: 5,
        defaultValue: 5,
        min: 2,
        max: 15,
        editable: true,
        lastModified: '2026-01-15',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'wiz.sesion_horas',
        name: 'Vigencia de sesión del wizard',
        description: 'Tiempo antes de forzar reautenticación del vendedor',
        category: 'wizard',
        kind: 'hours',
        value: 8,
        defaultValue: 8,
        min: 1,
        max: 24,
        editable: true,
        lastModified: '2026-01-15',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'wiz.retry_score_meses',
        name: 'Retryable after score rechazado',
        description: 'Ventana de veto antes de que el cliente pueda reintentar la solicitud',
        category: 'wizard',
        kind: 'months',
        value: 6,
        defaultValue: 6,
        min: 1,
        max: 24,
        editable: true,
        lastModified: '2026-04-02',
        lastModifiedBy: ADMIN,
    },
    // ---------- MOTOR DE CRÉDITO · umbrales ----------
    {
        id: 'motor.sci_minimo_elegible',
        name: 'SCI mínimo elegible',
        description: 'Score mínimo para ser considerado en originación (por debajo se rechaza)',
        category: 'engine',
        kind: 'number',
        value: 21,
        defaultValue: 21,
        min: 0,
        max: 100,
        editable: true,
        lastModified: '2026-02-20',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'motor.peso_c2_nuevo',
        name: 'Peso Capa 2 · cliente nuevo',
        description: 'Peso del reporte externo (Círculo BC) en el score final de un cliente nuevo',
        category: 'engine',
        kind: 'pct',
        value: 1.0,
        defaultValue: 1.0,
        min: 0,
        max: 1,
        editable: true,
        lastModified: '2026-02-20',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'motor.peso_c2_recurrente',
        name: 'Peso Capa 2 · cliente recurrente',
        description: 'Peso del reporte externo cuando el cliente ya tiene historial interno',
        category: 'engine',
        kind: 'pct',
        value: 0.3,
        defaultValue: 0.3,
        min: 0,
        max: 1,
        editable: true,
        lastModified: '2026-02-20',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'motor.peso_c3_recurrente',
        name: 'Peso Capa 3 · historial interno',
        description:
            'Peso del historial interno SureKeep en el score final de un cliente recurrente',
        category: 'engine',
        kind: 'pct',
        value: 0.7,
        defaultValue: 0.7,
        min: 0,
        max: 1,
        editable: true,
        lastModified: '2026-02-20',
        lastModifiedBy: ADMIN,
    },
    // ---------- COBRANZA · SLAs ----------
    {
        id: 'cob.sla_excep_alta_horas',
        name: 'SLA excepciones · alta',
        description: 'Tiempo máximo para atender una excepción de severidad alta',
        category: 'collections',
        kind: 'hours',
        value: 24,
        defaultValue: 24,
        min: 4,
        max: 72,
        editable: true,
        lastModified: '2026-03-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'cob.sla_excep_media_horas',
        name: 'SLA excepciones · media',
        description: 'Tiempo máximo para atender una excepción de severidad media',
        category: 'collections',
        kind: 'hours',
        value: 48,
        defaultValue: 48,
        min: 12,
        max: 120,
        editable: true,
        lastModified: '2026-03-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'cob.sla_excep_baja_horas',
        name: 'SLA excepciones · baja',
        description: 'Tiempo máximo para atender una excepción de severidad baja',
        category: 'collections',
        kind: 'hours',
        value: 72,
        defaultValue: 72,
        min: 24,
        max: 168,
        editable: true,
        lastModified: '2026-03-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'cob.dias_a_mora_dura',
        name: 'Días para pasar a mora dura',
        description: 'Después de este atraso el crédito pasa de mora temprana a mora dura',
        category: 'collections',
        kind: 'days',
        value: 30,
        defaultValue: 30,
        min: 15,
        max: 60,
        editable: true,
        lastModified: '2026-01-10',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'cob.dias_baja_contable',
        name: 'Días para baja contable',
        description: 'Después de este atraso el crédito se propone para baja contable',
        category: 'collections',
        kind: 'days',
        value: 180,
        defaultValue: 180,
        min: 90,
        max: 365,
        editable: true,
        lastModified: '2026-01-10',
        lastModifiedBy: ADMIN,
    },
    // ---------- FRAUDE · multiplicadores default ----------
    {
        id: 'fraude.antifraude_mult_default',
        name: 'Multiplicador anti-fraude default',
        description:
            'Multiplicador aplicado al promedio diario 30d para calcular el tope de cobros por tienda. Editable por tienda desde Conciliación del Admin VL',
        category: 'fraud',
        kind: 'number',
        value: 2.0,
        defaultValue: 2.0,
        min: 1.0,
        max: 5.0,
        editable: true,
        lastModified: '2026-05-14',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'fraude.c1_tasa_rechazo_alta_pct',
        name: 'Umbral C1 · tasa de rechazo alta',
        description:
            'Si el vendedor tiene tasa de rechazo por encima de este umbral levanta detector C1',
        category: 'fraud',
        kind: 'pct',
        value: 0.5,
        defaultValue: 0.5,
        min: 0.2,
        max: 0.9,
        editable: true,
        lastModified: '2026-06-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'fraude.c2_mora_temprana_pct',
        name: 'Umbral C2 · mora temprana',
        description: 'Vendedor con mora temprana superior levanta detector C2',
        category: 'fraud',
        kind: 'pct',
        value: 0.15,
        defaultValue: 0.15,
        min: 0.05,
        max: 0.4,
        editable: true,
        lastModified: '2026-06-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'fraude.c3_curps_duplicados',
        name: 'Umbral C3 · CURPs duplicados',
        description: 'Cantidad de CURPs distintos con múltiples solicitudes por el mismo vendedor',
        category: 'fraud',
        kind: 'number',
        value: 3,
        defaultValue: 3,
        min: 1,
        max: 10,
        editable: true,
        lastModified: '2026-06-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'fraude.c4_ticket_atipico_delta',
        name: 'Umbral C4 · ticket atípico Δ',
        description:
            'Desviación relativa contra el ticket promedio de la tienda que dispara detector C4',
        category: 'fraud',
        kind: 'pct',
        value: 0.4,
        defaultValue: 0.4,
        min: 0.15,
        max: 1.0,
        editable: true,
        lastModified: '2026-06-01',
        lastModifiedBy: ADMIN,
    },
    // ---------- CONTRATO · datos impresos ----------
    {
        id: 'contrato.razon_social_proveedor',
        name: 'Razón social del proveedor',
        description: 'Proveedor del equipo que imprime el contrato de crédito (Sección II.3)',
        category: 'contract',
        kind: 'text',
        value: 'SUREKEEP, S.A.P.I. de C.V., SOFOM, E.N.R.',
        defaultValue: 'SUREKEEP, S.A.P.I. de C.V., SOFOM, E.N.R.',
        editable: true,
        lastModified: '2026-10-13',
        lastModifiedBy: ADMIN,
    },
    // ---------- FEATURE FLAGS ----------
    {
        id: 'flag.wizard_v2',
        name: 'Wizard V2 activado',
        description: 'Corte de tráfico al wizard V2. Al desactivar vuelve al V1 legacy',
        category: 'flags',
        kind: 'bool',
        value: true,
        defaultValue: true,
        editable: true,
        lastModified: '2026-05-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'flag.prospectos_multi_dia',
        name: 'Prospectos multi-día',
        description: 'Pipeline de prospectos del Portal Vendedor · guardar prospecto para retomar',
        category: 'flags',
        kind: 'bool',
        value: true,
        defaultValue: true,
        editable: true,
        lastModified: '2026-05-01',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'flag.efectivo_folio_unico',
        name: 'Efectivo con folio único',
        description:
            'Cobros en efectivo con folio único como referencia de conciliación (sin fotos)',
        category: 'flags',
        kind: 'bool',
        value: true,
        defaultValue: true,
        editable: true,
        lastModified: '2026-06-15',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'flag.crossborder_activo',
        name: 'Cross-border activo',
        description: 'Módulo M5 · compras desde USA con recogida en tienda MX',
        category: 'flags',
        kind: 'bool',
        value: false,
        defaultValue: false,
        editable: true,
        lastModified: '2026-04-10',
        lastModifiedBy: ADMIN,
    },
    {
        id: 'flag.trustonic_activo',
        name: 'Bloqueo Trustonic activo',
        description:
            'Integración con Trustonic para bloqueo remoto del equipo. Alternativa mientras no se confirma proveedor MDM',
        category: 'flags',
        kind: 'bool',
        value: false,
        defaultValue: false,
        editable: true,
        lastModified: '2026-03-20',
        lastModifiedBy: ADMIN,
    },
];
